import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { upGame, addGame, queryGame } from '@/api/game';
import { Message } from "element-ui";
export default {
  data: function data() {
    var _this = this;

    var validate = function validate(rule, value, callback) {
      if (value === '') {
        callback(new Error(_this.$t('pleaseInput')));
      } else if (/[A-Z\u4e00-\u9fa5]/.test(value)) {
        callback(new Error(_this.$t('cannotContainUppercaseChinese')));
      } else {
        callback();
      }
    };

    return {
      dialogFormVisible: false,
      form: {
        game_name: "",
        status: 1,
        game_mark: "",
        id: ""
      },
      rules: {
        game_name: [{
          required: true,
          message: this.$t('pleaseInputGameName'),
          trigger: "blur"
        }],
        game_mark: [{
          required: true,
          validator: validate,
          trigger: "blur"
        }]
      },
      formLabelWidth: "80px"
    };
  },
  created: function created() {},
  methods: {
    init: function init(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var query;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!id) {
                  _context.next = 5;
                  break;
                }

                _context.next = 3;
                return queryGame({
                  id: id
                });

              case 3:
                query = _context.sent;
                _this2.form = _objectSpread({}, query.data);

              case 5:
                _this2.dialogFormVisible = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.form = {
        game_name: "",
        status: 1,
        game_mark: "",
        id: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this3 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(vali) {
          var reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (vali) {
                    reqFn = _this3.form.id ? upGame : addGame;
                    reqFn(_this3.form).then(function (res) {
                      if (res.status == 200) {
                        Message.success(_this3.$t('operationSuccess'));
                        _this3.dialogFormVisible = false;

                        _this3.$emit("change");
                      }
                    });
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};